// import { authHeader } from './auth-header';
import axios from "axios";
import { ERROR_MSGS} from "@/helpers/errorHandlers/error-messeges";

export const userService = {
    login,
    logout,
    register,
    authUser,
    startRefreshTokenTimer,
    refreshUserToken,
    setUserTokens,
    getUserProfile,
    setUserInfo,
    refreshToken,
    removeTokens,
    forgotPassword,
    checkExpirationPasswordLink,
    resetPassword,
    createPassword,
    getUserPermissions,
    liveChatSupport
};

function authUser(loginRequest) {
    return new Promise((res, rej) => {
        axios
            .post(process.env.VUE_APP_BACKEND_URL + "api/mobile-users/auth", loginRequest)
            .then((response) => {
                const resp = response.data.content;
                this.startRefreshTokenTimer(response.data.content.expires_in)
                res(resp);
            })
            .catch((err) => {
                const code =
                    err.validationFailures && err.validationFailures[0]
                        ? err.validationFailures[0].code
                        : "";
                if (code == "invalid_grant.2BadCredentials") {
                    err.message = ERROR_MSGS.INCORRECT_PASSWORD;
                } else if (code == "invalid_grant.UserAccountLocked") {
                    err.message = ERROR_MSGS.ACC_LOCK;
                }
                rej(err);
            });
    });
}
function startRefreshTokenTimer(expires_in){
    const timeout = (expires_in * 60) - ( 60 * 1000);
    setTimeout(() => this.refreshUserToken(), timeout);
}

function refreshUserToken(){
    const refresh_token = localStorage.getItem("refreshToken");
    if (refresh_token) {
        const loginRequest = {
            grant_type: "refresh_token",
            refresh_token: refresh_token,
        };
        axios
            .post(process.env.VUE_APP_BACKEND_URL + "api/mobile-users/auth", loginRequest)
            .then((response) => {
                const resp = response.data.content;
                this.startRefreshTokenTimer(resp.expires_in);
                this.setUserTokens(resp.access_token, resp.refresh_token);
            })
            .catch((err) => {
                console.warn("Refresh token request failed:", err.message || err);
            });
    }
}

function setUserTokens(token, refreshToken){
    localStorage.setItem("jwtToken", token);
    localStorage.setItem("refreshToken", refreshToken);
    getUserPermissions();
}

function removeTokens(){

    localStorage.removeItem('jwtToken');
    localStorage.removeItem('refreshToken');
}
function getUserProfile(){
    return new Promise((res, rej) => {
        axios
            .get(process.env.VUE_APP_BACKEND_URL + "api/merchants/current-user")
            .then((response) => {
                res(response.data.content);
            })
            .catch((err) => {
                rej(err);
            });
    });
}

function refreshToken() {
    const refresh_token = localStorage.getItem("refreshToken");
    if (refresh_token) {
        this.refreshUserToken();
    }
}

function setUserInfo(userInfo) {
    localStorage.setItem("merchant", JSON.stringify(userInfo));
    localStorage.setItem("merchantID", JSON.stringify(userInfo.merchant.id))
    localStorage.setItem("userID", JSON.stringify(userInfo.id))
    localStorage.setItem("merchantBranchId", JSON.stringify(userInfo.merchantBranch?.id))
    localStorage.setItem("merchantVatNo", JSON.stringify(userInfo.merchant.vatNo))
}
function login(email, password) {

    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
    };

    return fetch(`/users/authenticate`, requestOptions)
        .then(handleResponse)
        .then(user => {
            if (user.token) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('user', JSON.stringify(user));
            }
            return user;
        });
}

function logout() {
    localStorage.removeItem('merchant');
    localStorage.removeItem('merchantID');
    localStorage.removeItem('userID');

    this.removeTokens()
}

function register(user) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(user)
    };
    return fetch(`/users/register`, requestOptions).then(handleResponse);
}

function forgotPassword(forgotrequest) {
    return new Promise((res, rej) => {
        axios
            .post(process.env.VUE_APP_BACKEND_URL + "api/merchant-users/password-reset", forgotrequest)
            .then((response) => {
                res(response.data.content);
            })
            .catch((err) => {
                rej(err);
            });
    });
}

function checkExpirationPasswordLink(formData, merchantUserId) {
    return new Promise((res, rej) => {
        axios
            .post(process.env.VUE_APP_BACKEND_URL + 'api/merchant-users/password/' + merchantUserId + '/link-expiration', formData)
            .then((response) => {
                res(response.data.content);
            })
            .catch((err) => {
                rej(err);
            });
    });
}

function resetPassword(formData, merchantUserId) {
    return new Promise((res, rej) => {
        axios
            .put(process.env.VUE_APP_BACKEND_URL + 'api/merchant-users/password-reset/'+merchantUserId, formData )
            .then((response) => {
                res(response.data.content);
            })
            .catch((err) => {
                rej(err);
            });
    });
}

function createPassword(formData, merchantUserId) {
    return new Promise((res, rej) => {
        axios
            .put(process.env.VUE_APP_BACKEND_URL + 'api/merchant-users/password-create/'+merchantUserId, formData )
            .then((response) => {
                res(response.data.content);
            })
            .catch((err) => {
                rej(err);
            });
    });
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                logout();
                location.reload(true);
            }
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}
function getUserPermissions() {
    const AuthorizationKeys = {
        Dashboard: ['ls-br-order-trend', 'ls-al-order-trend'],
        Finance: 'v-musr-acc',
        Billing: 'cr-odr',
        Orders: ['ls-ow-odr', 'ls-br-odr', 'ls-al-odr'],
        'Profile Management': 'ls-musr',
        'Action History': ['ls-ow-actlog', 'ls-br-actlog', 'ls-al-actlog'],
        Campaigns: 'app-mcam-apl',
        'Static QR': ['ls-al-sqr', 'ls-br-sqr'],
        create_merchant_button: 'cr-musr',
        cashier_dashboard_branch_filter: 'ls-al-order-trend'
    }

    function parseJwt(token) {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(
            atob(base64)
                .split('')
                .map(c => {
                    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                })
                .join('')
        );

        localStorage.setItem('profileManagementAuthorities', jsonPayload);
        return JSON.parse(jsonPayload);
    }

    const token = localStorage.getItem('refreshToken');
    const decodedToken = parseJwt(token);
    const authorities = decodedToken.authorities;
    const matchedKeys = [];
    authorities.forEach(authority => {
        for (const key in AuthorizationKeys) {
            if (Object.prototype.hasOwnProperty.call(AuthorizationKeys, key)) {
                if (Array.isArray(AuthorizationKeys[key])) {
                    if (AuthorizationKeys[key].includes(authority)) {
                        matchedKeys.push(key);
                    }
                } else {
                    if (AuthorizationKeys[key] === authority) {
                        matchedKeys.push(key);
                    }
                }
            }
        }
    });

    // create_merchant_button
    const isCreateMerchantAllowed = authorities.includes(AuthorizationKeys.create_merchant_button);
    localStorage.setItem('isCreateMerchantAllowed', isCreateMerchantAllowed);

    // cashier_dashboard_branch_filter
    const isBranchFilterAllowed = authorities.includes(AuthorizationKeys.cashier_dashboard_branch_filter);
    localStorage.setItem('isBranchFilterAllowed', isBranchFilterAllowed);

    // user permissions
    const userPermission = matchedKeys;
    localStorage.setItem('menuDisplayAuthorities', JSON.stringify(userPermission));
    return userPermission;
}

function liveChatSupport() {
    function initFreshChat() {
        window.fcWidget.init({
        token: "ad940638-0ac0-4e1e-bce2-dbcfe565ebf5",
        host: "https://paykoko-team.freshchat.com",
        widgetUuid: "b2af7069-0ba6-455d-a8ea-c1f8f618fc30"
        });
    }
    function initialize(i,t){
        var e;
        if(i.getElementById(t)){
        initFreshChat();
        } else {
        e = i.createElement("script");
        e.id = t;
        e.async = true;
        e.src = "https://paykoko-team.freshchat.com/js/widget.js";
        e.onload = initFreshChat;
        i.head.appendChild(e);
        }
    }
    function initiateCall() {
        initialize(document, "Freshchat-js-sdk");
    }
    window.addEventListener ? window.addEventListener("load", initiateCall, false) : window.attachEvent("load", initiateCall, false);
}
